export default __webpack_public_path__ + "static/media/s0_female.51cc369d.wav";